import styled, { css } from 'styled-components';
import { getFadeAnimation } from '@/styles/helpers';

const FullHeight = css`
  width: 100%;
  min-height: var(--overlay-doc-height, 100%);
`;

const AutoHeight = css`
  right: 0;
  bottom: -80px;
`;

export const OverlayBox = styled.div<{
  $isOpen: boolean;
  $opacity?: number;
  $coverDocument: boolean;
}>`
  top: 0;
  left: 0;
  z-index: 10100;
  background-color: ${({ $opacity }) => `rgba(0, 0, 0, ${$opacity ?? 0.4})`};
  position: ${({ $coverDocument }) => ($coverDocument ? 'absolute' : 'fixed')};

  ${({ $isOpen }) => getFadeAnimation($isOpen)}
  ${({ $coverDocument }) => ($coverDocument ? FullHeight : AutoHeight)}
`;
